import {BaseStore, globalStore} from "../../../../stem-core/state/Store";
import {field} from "../../../../stem-core/state/StoreField.js";
import {apiClient, type MerchantScopedRequest} from "../../../connection/BlinkApiClient.js";
import type {StoreId} from "../../../../stem-core/state/State";
import type {Merchant} from "../../MerchantStore";
import type {MerchantCDSProduct} from "./MerchantCDSProductStore";
import type {SubscriptionOffer} from "../../SubscriptionOfferStore";

@globalStore
export class MerchantCDSPromoKeys extends BaseStore("MerchantCDSPromoKeys") {
    @field("Merchant") merchant: Merchant;
    @field("MerchantCDSProduct") product: MerchantCDSProduct;
    @field("SubscriptionOffer") subscriptionOffer: SubscriptionOffer;
    @field(Array) promoKeys: string[];
    @field(Boolean) allowUnverified: boolean;
}

// MerchantEditCDSPromoKeysRequest (api/external_providers/views.py)
export interface MerchantEditCDSPromoKeysRequest extends MerchantScopedRequest {
    productId: StoreId;
    subscriptionOfferId: StoreId;
    promoKeys: string[];
    allowUnverified: boolean;
}

export async function apiMerchantEditCDSPromoKeys(request: MerchantEditCDSPromoKeysRequest): Promise<any> {
    return apiClient.post("/external_providers/edit_cds_promo_keys/", request);
}